import KeepCollapse from './Collapse.vue';
import KeepCollapsePanel from './CollapsePanel.vue';

export default {
    KeepCollapse,
    KeepCollapsePanel,
};
